/**
 * Website images in the block editor: per-member team photos, block photos (text, services, team, contact,
 * reviews, packages), photo shape (auto-fit) and the inline focal point / alt text panel.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["si.adjust", "Adjust", "调整"],
  ["si.adjustTitle", "Focal point & alt text", "焦点与替代文字"],
  ["si.focalHint", "Tap the face or the most important spot. When the photo has to be cropped (round, square, portrait frames) it stays in view.", "点一下脸部或最重要的位置。照片需要裁切（圆形、方形、竖幅）时，会保留这个位置。"],
  ["si.altHint", "Describes the photo for Google and screen readers, e.g. \"Anna styling a bob cut\".", "给 Google 和读屏软件看的图片说明，例如「Anna 正在剪波波头」。"],
  ["si.save", "Save", "保存"],
  ["si.saved", "Photo settings saved", "图片设置已保存"],
  ["si.fit", "Photo shape", "图片形状"],
  ["si.fit.auto", "Auto (fits the photo)", "自动（适应照片）"],
  ["si.fit.original", "Whole photo (never cropped)", "完整照片（不裁切）"],
  ["si.fit.square", "Square 1:1", "方形 1:1"],
  ["si.fit.portrait", "Portrait 3:4", "竖幅 3:4"],
  ["si.fit.landscape", "Landscape 4:3", "横幅 4:3"],
  ["si.fit.wide", "Wide 16:9", "宽幅 16:9"],
  ["si.fitHint", "Auto keeps the photo's own shape (portrait, square or landscape); only extremely tall or wide photos are trimmed, around the focal point.", "自动：按照片本身的比例显示（竖图、方图、横图都可以）；只有特别高或特别宽的照片才会围绕焦点稍作裁切。"],
  ["si.blockImg", "Photo", "图片"],
  ["si.imgSide", "Photo position", "图片位置"],
  ["si.side.top", "Above the text", "文字上方"],
  ["si.side.left", "Left", "左侧"],
  ["si.side.right", "Right", "右侧"],
  ["si.teamPhotos", "Member photos", "成员照片"],
  ["si.teamPhotosHint", "Each member uses their team photo from Website → Images. Upload or choose a photo here to change it: an upload is also saved as that member's team photo. Tap Adjust to keep the face in view.", "每位成员默认使用「官网 → 图片」里的团队照片。在这里上传或选择即可更换：上传的照片也会保存为该成员的团队照片。点「调整」可让脸部保持在画面中。"],
  ["si.teamPhotosAll", "No members ticked above: the site shows everyone switched on in the Content page, so all members are listed here.", "上面没有勾选成员：网站会显示「内容」页中开启的全部成员，因此这里列出所有成员。"],
  ["si.memberDefault", "Team photo", "团队照片"],
  ["si.noPhoto", "No photo yet — the site shows their initial", "还没有照片，网站会显示名字首字"],
  ["si.groupImg", "Group / salon photo (optional, above the members)", "团体照 / 店内照（可选，显示在成员上方）"],
  ["si.quoteImg", "Customer photo (optional, with their permission)", "顾客照片（可选，需征得同意）"],
  ["si.pkgImg", "Photo (optional)", "图片（可选）"],
  ["si.contactImg", "Photo next to the contact details (e.g. your shop front)", "联系方式旁的图片（例如店面）"],
  ["si.servicesImg", "Photo above the menu (optional)", "服务菜单上方的图片（可选）"],
  ["si.textImg", "Photo (optional)", "图片（可选）"],
  ["si.reset", "Use team photo", "改用团队照片"],
  ["si.uploadHint", "JPG, PNG or WebP. Big photos are resized automatically.", "支持 JPG、PNG、WebP，大图会自动压缩。"],
] as const;
export type SiKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<SiKey, string>;

export const siteImg = { en: col(1), zh: col(2), ms: col(1) };
